import React from 'react';
import { CheckCircle2Icon, FileTextIcon, MessageSquareIcon, Edit3Icon, ClockIcon } from 'lucide-react';
import { ActivityEvent } from '../types';
interface ActivityTimelineProps {
  events: ActivityEvent[];
  embedded?: boolean;
}
export function ActivityTimeline({
  events,
  embedded = false
}: ActivityTimelineProps) {
  const getEventIcon = (type: ActivityEvent['type']) => {
    switch (type) {
      case 'order_placed':
        return <CheckCircle2Icon className="h-4 w-4 text-blue-500" data-id="element-22" />;
      case 'document_shared':
        return <FileTextIcon className="h-4 w-4 text-purple-500" data-id="element-23" />;
      case 'status_update':
        return <ClockIcon className="h-4 w-4 text-emerald-500" data-id="element-24" />;
      case 'field_update':
        return <Edit3Icon className="h-4 w-4 text-slate-400" data-id="element-25" />;
      case 'message':
        return <MessageSquareIcon className="h-4 w-4 text-indigo-500" data-id="element-26" />;
    }
  };
  const getEventBg = (type: ActivityEvent['type']) => {
    switch (type) {
      case 'order_placed':
        return 'bg-blue-50 ring-blue-100';
      case 'document_shared':
        return 'bg-purple-50 ring-purple-100';
      case 'status_update':
        return 'bg-emerald-50 ring-emerald-100';
      case 'field_update':
        return 'bg-slate-50 ring-slate-200';
      case 'message':
        return 'bg-indigo-50 ring-indigo-100';
    }
  };
  const content = <div className="flow-root" data-id="element-27">
      <ul role="list" className="-mb-4" data-id="element-28">
        {events.map((event, eventIdx) => <li key={event.id} data-id="element-29">
            <div className="relative pb-5" data-id="element-30">
              {eventIdx !== events.length - 1 ? <span className="absolute left-4 top-5 -ml-px h-full w-0.5 bg-slate-100" aria-hidden="true" data-id="element-31" /> : null}
              <div className="relative flex items-start space-x-3" data-id="element-32">
                <div className="relative" data-id="element-33">
                  <span className={`flex h-8 w-8 items-center justify-center rounded-full ring-4 ring-white ${getEventBg(event.type)}`} data-id="element-34">
                    {getEventIcon(event.type)}
                  </span>
                </div>
                <div className="min-w-0 flex-1 pt-0.5" data-id="element-35">
                  <div className="flex items-baseline gap-2 flex-wrap" data-id="element-36">
                    <span className="text-xs font-semibold text-slate-900" data-id="element-37">
                      {event.title}
                    </span>
                    <span className="text-[10px] text-slate-400 whitespace-nowrap" data-id="element-38">
                      {event.timestamp}
                    </span>
                  </div>
                  <p className="mt-0.5 text-xs text-slate-600 leading-relaxed" data-id="element-39">
                    {event.description}
                  </p>
                  {event.user && <p className="mt-0.5 text-[10px] text-slate-400 font-medium" data-id="element-40">
                      By {event.user}
                    </p>}
                </div>
              </div>
            </div>
          </li>)}
      </ul>
    </div>;
  if (embedded) return content;
  return <div className="bg-white rounded-lg shadow-sm border border-slate-200 p-4" data-id="element-41">
      {content}
    </div>;
}